import React from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';
import ImageComponent from '../../components/ImageComponent';
import { useTranslation } from 'react-i18next';
interface LeaderboardLinkProps {
    iconSrc: string;
    onclick:()=>void
}
export const LeaderboardLink: React.FC<LeaderboardLinkProps> = ({  iconSrc ,onclick}) => {
  const {t} = useTranslation();
  return (
    <div className={clsx(styles.leaderboardLink, "fontSizeSm14 fontWeightBold")} tabIndex={0} role="button" onClick={onclick}>
      <p className={styles.leaderboardText}>{t("leaderboard")}</p>
      <ImageComponent
        src={iconSrc}
        className={styles.leaderboardIcon}
        alt="chevron icon"
      />
    </div>
  );
};